import ImageWithFallback from '@/globalComponents/image';
import Button from '@/shared/Button';
import Div from '@/shared/Div';
import Paragraph from '@/shared/Paragraph';
import Price from './Price';

const ProductTile = ({ attributes, price }: any) => {
  const { name, slug, productId, media } = attributes;

  return (
    <Button theme="none" href={`/p/${slug}/${productId}`}>
      <Div className="shadow-xl p-2 w-fit rounded-cxs">
        <ImageWithFallback
          key={media.data[0].id}
          src={media.data[0].attributes.url}
          width={400}
          height={400}
          alt={name}
          className=" h-auto object-fill"
        />
        <Paragraph className="font-semibold">{name}</Paragraph>
        <Price value={{ price }} />
      </Div>
    </Button>
  );
};

export default ProductTile;
